import styled, { css, keyframes } from 'styled-components';

export const colors = {
  white: '#E3E3E3',
  blue: '#5EABE3',
  green: '#98C892',
  yellow: '#FBAF4F',
  red: '#DF5B60',
  gray: '#343D46',
  noteColor: '#FFDE52',
  commentGray: '#424E59',
  lightGray: '#475460',
};

const animate = css`
  -webkit-transition: all 0.3s ease-out;
  -moz-transition: all 0.3s ease-out;
  transition: all 0.3s ease-out;
`;

export const AppContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow: hidden;
`;

export const Main = styled.div`
  width: ${props => (props.sidebar ? 50 : 100)}%;
  height: 100%;
  background: ${props => (props.editing ? 'white' : '#343D46}')};
  color: #e3e3e3;
  position: relative;
  ${animate}
  @media only screen and (max-width: 600px) {
    width: 100%;
  }
`;

export const Sidebar = styled.div`
  width: 50%;
  height: 100%;
  top: 0px;
  position: fixed;
  background: ${colors.white};
  right: ${props => (props.sidebar ? 0 : 'calc(0px - 50%)')};
  ${animate}
  ${props =>
    props.sidebar &&
    css`
      @media only screen and (max-width: 600px) {
        width: 100%;
        right: 0;
        top: 0px;
        position: absolute;
      }
    `}
`;

export const AddText = styled.div`
  width: 20%;
  height: 100%;
  display: flex;
  cursor: pointer;
  justify-content: center;
  flex-direction: row;
  padding-top: 15px;
  @media only screen and (max-width: 600px) {
    height: 100px;
    width: 100%;
  }
  user-select: none;
  ${props => props.hide && css`
    opacity: 0;
  `}
`;

export const UploadImage = styled.div`
  width: 22px;
  height: 22px;
  background: ${props =>
    props.editing ? 'url(editcolor.png)' : 'url(edittext.png)'};
  background-size: 100%;
  background-repeat: no-repeat;
  margin: 25px 10px;
`;

export const UploadInfo = styled.p`
  font-size: 22px;
  font-weight: bold;
  width: 100px;
  color: ${props => (props.editing ? colors.gray : colors.white)};
`;

export const Controls = styled.div`
  width: calc(100% - 20px);
  height: 100px;
  padding: 10px;
  background: ${props => (props.editing ? 'white' : '#343D46')};
  border-top: 1px solid #e3e3e3;
  display: flex;
  position: absolute;
  bottom: 0;
  z-index: 9998;
  @media only screen and (max-width: 600px) {
    height: 150px;
    flex-direction: column-reverse;
  }
  ${props =>
    props.sidebar &&
    css`
      @media only screen and (max-width: 600px) {
        height: 100px;
      }
    `}
`;

export const Upload = styled.div`
  width: 20%;
  height: 100%;
  display: flex;
  cursor: pointer;
  justify-content: center;
  flex-direction: column;
  text-align: center;
  @media only screen and (max-width: 600px) {
    height: 100px;
    width: 100%;
  }
`;

export const Styles = styled.div`
  width: ${props => (props.sidebar ? '100%' : '80%')};
  height: 100%;
  display: flex;
  justify-content: ${props => (props.sidebar ? 'center' : 'flex-end')};
  align-items: center;
  ${props =>
    props.editing &&
    css`
      opacity: 0.5;
      pointer-events: none;
    `}
  @media only screen and (max-width: 600px) {
    height: 100px;
    width: 100%;
    justify-content: center;
  }
`;

export const Color = styled.div`
	background: ${props => props.color};
	border: ${props => (props.selected ? '6px solid white' : 0)}
	width: 60px;
	height: 60px;
	min-width: 60px;
	border-radius: 100%;
	margin-right: ${props => (props.selected ? 'calc(5% - 6px)' : 'calc(5%)')};
	margin-left: ${props => (props.selected ? '-6px' : '0')}
	cursor: pointer;
	${props =>
    props.noting &&
    css`
      background-image: url('commentsicon.png');
      background-repeat: no-repeat;
      background-position: center;
      background-size: 60%;
    `}
	${props =>
    props.delete &&
    css`
      background-image: url('commentsx.png');
      background-repeat: no-repeat;
      background-position: center;
      background-size: 60%;
    `}
	${props =>
    props.info &&
    css`
      background: url('info.png');
      background-repeat: no-repeat;
      background-position: center;
      background-size: 90%;
    `}
	}
	${props =>
    props.sidebar &&
    css`
      @media only screen and (max-width: 800px) {
        height: 40px;
        width: 40px;
        min-width: 40px;
      }
    `}
  ${props => props.hide && css`
    opacity: 0;
  `}
	@media only screen and (max-width: 400px) {
		height: 40px;
		width: 40px;
		min-width: 40px;
	}
`;

export const EditorContainer = styled.div`
  width: calc(100% - 40px);
  overflow: auto;
  height: calc(100% - 190px);
  padding: 35px 35px 35px 5px;
  font-size: 24px;
  margin: 0;
  font-family: 'Ubuntu Mono';
  white-space: nowrap;
  @media only screen and (max-width: 600px) {
    font-size: 18px;
    height: calc(100% - 210px);
  }
`;

export const TextArea = styled.textarea`
  width: 100%;
  height: 100%;
  flex-grow: 3;
  font-size: 24px;
  background: 0;
  color: ${colors.gray};
  outline: 0;
  border: 0;
  margin: -2px;
  resize: none;
  font-family: 'Ubuntu Mono';
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
`;

export const Word = styled.span`
	color: ${props => props.color};
  opacity: ${props => props.invisible ? 0 : 1};
  background-color: ${props => props.background || 0};
	${props =>
    props.underline &&
    css`
      text-decoration: underline;
      text-decoration-color: ${props => props.color};
    `}
	${props =>
    props.bold &&
    css`
      font-weight: 1000;
    `}
	${props =>
    props.italic &&
    css`
      font-style: italic;
    `}
	${props =>
    props.noteWord &&
    css`
      color: ${colors.noteColor};
    `}

	cursor: pointer;
`;

export const PaginationContainer = styled.div``;

export const PageLeft = styled.div`
  position: fixed;
  left: 0;
  top: calc(50% - 50px);
  width: 30px;
  height: 100px;
  background: #e3e3e3;
  border-radius: 0 5px 5px 0;
  cursor: pointer;
  &:after {
    content: '<';
    font-size: 38px;
    position: absolute;
    left: 4px;
    top: calc(100% / 2 - 24px);
    color: #343d46;
    font-weight: bold;
  }
`;
export const PageRight = styled.div`
  position: fixed;
  right: 0;
  top: calc(50% - 50px);
  width: 30px;
  height: 100px;
  background: #e3e3e3;
  border-radius: 5px 0 0 5px;
  cursor: pointer;
  &:after {
    content: '>';
    font-size: 38px;
    position: absolute;
    right: 4px;
    top: calc(100% / 2 - 24px);
    color: #343d46;
    font-weight: bold;
  }
`;

export const PasteInputContainer = styled.div`
  width: 90%;
  height: 90%;
  left: 5%;
  top: 5%;
  background: ${colors.gray};
  border-radius: 20px;
  position: absolute;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  border: 2px solid white;
`;

export const Instruction = styled.h1`
  width: 100%;
  color: ${colors.gray};
`;

export const Buttons = styled.div`
  display: flex;
  flex-grow: 1;
  width: 100%;
  justify-content: space-around;
  margin-top: 50px;
`;

export const Button = styled.button`
  text-align: center;
  width: 200px;
  height: 60px;
  background: ${props => {
    if (props.cancel) {
      return colors.red;
    } else {
      return colors.green;
    }
  }};
  cursor: pointer;
  color: white;
  border-radius: 5px;
  font-size: 20px;
  &:focus {
    outline: 0;
  }
  font-weight: bolder;
  margin: 5px;
  border: none;
  outline: 0;
`;

export const Overlay = styled.div`
  width: 100%;
  height: 100%;
  background: 0;
  z-index: 1;
  position: fixed;
  left: 0;
  top: 0;
  ${props => props.dark && css`
    background: ${colors.gray};
    opacity: 0.2;
  `}
`;

export const Hamburger = styled.div`
  width: 32px;
  height: 32px;
  background: ${props => {
    if (props.closed) {
      return 'url(hamburger-closed.png)';
    }
    return 'url(hamburger-open.png)';
  }};
  fill: #e3e3e3;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 32px;
  position: fixed;
  right: 10px;
  top: 10px;
  z-index: 9999;
  cursor: pointer;
`;

export const WordListContainer = styled.div`
  width: 100%;
  height: 100%;
  background: white;
  @media only screen and (max-width: 600px) {
    height: calc(100% - 100px);
  }
`;

export const WordListInput = styled.textarea`
  width: calc(100% - 80px);
  height: calc(100% - 370px);
  background: 0;
  margin: 20px;
  resize: none;
  font-size: 24px;
  padding: 20px;
  color: ${props => props.color};
  outline: 0;
  border: none;
  &:focus {
    outline: 0;
  }
  color: ${props => props.c};
  ${props =>
    props.u &&
    css`
      text-decoration: underline;
      text-decoration-color: ${props => props.c};
    `}
  ${props =>
    props.b &&
    css`
      font-weight: bolder;
    `}
  ${props =>
    props.i &&
    css`
      font-style: italic;
    `}
`;

export const InfoContainer = styled.div`
  overflow-y: scroll;
  height: calc(100% - 295px);
  width: 100%;
`;

export const Info = styled.div`
  width: auto;
  height: auto;
  background: 0;
  margin: 0px 20px;
  font-size: 24px;
  padding: 20px 20px 0px 20px;
  color: ${colors.gray};
  outline: none;
  border: none;
  &:focus {
    outline: 0;
  }
`;

export const By = styled.div`
  background: 0;
  font-size: 24px;
  color: ${colors.gray};
  margin: 20px;
  padding: 20px;
`;

export const Options = styled.div`
  height: 210px;
  display: flex;
  flex-direction: column;
  margin: 0px 20px 0px 20px;
  padding: 20px 20px 20px 20px;
`;

const flash = keyframes`
  0% {
  	opacity: 1
  }
  50% {
    opacity: 0;
  }
  100% {
  	opacity: 1
  }
`;

export const SingleOption = styled.div`
  width: calc(100% - 80px);
  height: 100px;
  display: flex;
  vertical-align: center;
  align-items: center;
  font-size: 22px;
  cursor: pointer;
  ${props =>
    props.animate &&
    css`
      animation: ${flash} 1s linear infinite;
    `}
`;
export const OptionText = styled.p`
  height: auto;
  margin: 0;
  padding: 0;
  user-select: none;
`;

export const OptionIcon = styled.div`
  width: 48px;
  height: 48px;
  background: ${props => {
    return `url(${props.url})`;
  }};
  min-width: 48px;
  fill: #e3e3e3;
  background-repeat: no-repeat;
  background-position: center;
  background-size: 48px;
  margin: 0 15px 0 0;
  padding: 0;
`;

export const LinkContainer = styled.div`
  height: 100px;
  background: ${colors.green};
  position: absolute;
  left: 0;
  top: 0;
  width: 100%;
`;
export const LinkText = styled.p`
  color: white;
  font-size: 22px;
  font-weight: bold;
  margin: 15px;
`;

export const LinkInput = styled.input`
  margin: -7px 10px;
  width: calc(100% - 40px);
  padding: 10px;
  font-size: 16px;
  height: 20px;
  outline: 0;
  border: 0;
  cursor: pointer;
  ${props =>
    props.copied &&
    css`
      animation: ${flash} 1s linear;
    `}
`;

export const Copied = styled.p`
  padding: 5px;
  background: ${colors.yellow};
  color: white;
  position: absolute;
  bottom: -7px;
  right: 9px;
  border-radius: 5px;
`;

export const SectionTitle = styled.div`
  padding: 10px 10px 10px 20px;
  background: ${props => props.background};
  color: ${props => props.color || props.c};
  font-size: 20px;
  ${props =>
    props.u &&
    css`
      text-decoration: underline;
      text-decoration-color: ${props => props.c};
    `}
  ${props =>
    props.b &&
    css`
      font-weight: bolder;
    `}
  ${props =>
    props.i &&
    css`
      font-style: italic;
    `}
`;

export const NoteContainer = styled.div`
	position: fixed;
	left: ${props => props.coords[0] - 40}px;
	top: ${props => props.coords[1] + 22}px;
	width: 300px;
	height: 200px;
	resize: vertical
	z-index: 2;
	background: ${colors.noteColor};
	box-sizing: border-box;
	padding: 5px;
	border: 1px solid #343D46;
	${props =>
    props.noteArrow &&
    css`
      &::after {
        content: '';
        position: absolute;
        bottom: 100%;
        left: 25px;
        width: 0;
        height: 0;
        border-left: 15px solid transparent;
        border-right: 15px solid transparent;
        border-top: 15px solid ${colors.noteColor};
        transform: rotate(180deg);
      }
      &&:before {
        content: '';
        position: absolute;
        bottom: 100%;
        left: 25px;
        width: 0;
        height: 0;
        border-left: 16px solid transparent;
        border-right: 16px solid transparent;
        border-top: 16px solid ${colors.noteColor};
        transform: rotate(180deg);
      }
      &&:before {
        border-right: 15px solid hsla(0, 0%, 0%, 0.1);
        bottom: -18px;
        left: 20px;
        z-index: 1;
        transform: rotate(180deg);
      }
      &&:before {
        pointer-events: none;
        border-right: 16px solid transparent;
        border-bottom: 16px solid transparent;
        border-top: 16px solid #343d46;
        bottom: 100%;
        left: 24px;
        z-index: 0;
        transform: rotate(180deg);
      }
    `}
`;
export const NoteInput = styled.textarea`
  outline: 0;
  border: none;
  width: 100%;
  height: calc(200px - 10px);
  padding: 5px;
  box-sizing: border-box;
  background: 0;
  font-size: 14px;
  min-height: 20px;
  font-style: italic;
`;

export const NoteContent = styled.div`
  outline: 0;
  border: none;
  width: 100%;
  height: 100vh;
  padding: 5px;
  box-sizing: border-box;
  font-size: 14px;
  min-height: 20px;
  ${props =>
    props.placeholder &&
    css`
      color: #a69853;
    `}
`;

export const NotesListContainer = styled.div`
  overflow-y: scroll;
  height: calc(100% - 295px);
`;
export const NotesListNewWord = styled.input`
  height: 25px;
  margin: 10px;
  width: calc(100% - 35px);
  padding: 5px;
  font-size: 16px;
  font-style: italic;
`;
export const WordContainer = styled.div`
  display: flex;
  align-items: center;
  margin: 10px 20px;
  padding: 5px;
  cursor: pointer;
  font-size: 20px;
  ${props =>
    props.editing &&
    css`
      cursor: auto;
    `}
`;
export const NotesListWord = styled.p`
  color: ${props => props.color};
  font-weight: bolder;
  position: relative;
  margin: 0 20px 0 0;
`;
export const NotesListInput = styled.input`
  height: 100%;
  font-size: 20px;
  position: relative;
  border: 0;
  outline: 0;
  width: 100%;
  font-style: italic;
`;
export const NotesListNote = styled.p`
  position: relative;
  margin: 0px;
`;
export const NotesListDelete = styled.div`
  width: 24px;
  height: 24px;
  background-image: url(deletesmallicon.png);
  background-size: 100%;
  background-repeat: no-repeat;
  cursor: pointer;
  margin-right: 10px;
  background-position: center;
`;

// New style editor implementation
export const StyleEditor = styled.div`
  width: auto;
  height: 60px;
  margin-right: 50px;
  display: flex;
  vertical-align: center;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  position: relative;
  background-color: ${colors.lightGray};
  z-index: 9999;
`;
export const IconContainer = styled.div`
  width: 60px;
  height: 60px;
  background-color: ${props => props.color};
  border-left: ${props => {
    if (props.boldSelected) {
      return `2px solid ${colors.white}`
    }
    return props.borderColor && `2px solid ${props.borderColor}`
  }
  };
  cursor: pointer;
  ${props => props.borderRight && css`
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
  `};
  ${props => props.borderLeft && css`
    border-top-left-radius: 10px;
    border-bottom-left-radius: 10px;
  `};
`;
export const StyleEditorIcon = styled.div`
  width: 24px;
  height: 26px;
  margin: 18px 17px;
  background-image: url(${props => props.img});
  background-size: 100%;
  background-repeat: no-repeat;
  box-sizing: border-box;
`;

// Color Picker
export const PickerContainer = styled.div`
  width: ${props => props.width ? `${props.width}px` : '330px'};
  height: ${props => props.height ? `${props.height}px` : '210px'};
  position: absolute;
  left: ${props => (props.left ? `${props.left}px` : 'calc(50% - 105px)')};
  top: ${props => props.height ? `-${props.height + 21}px` : '-231px'};
  background: ${colors.gray};
  border: 1px solid ${colors.white};
  border-radius: 4px;
  z-index: 9999;
  &::after,
  &::before {
    top: 100%;
    left: 50%;
    border: solid transparent;
    content: ' ';
    height: 0;
    width: 0;
    position: absolute;
    pointer-events: none;
  }
  &::after {
    border-top-color: ${colors.gray};
    border-width: 20px;
    margin-left: -20px;
  }
  &::before {
    border-top-color: ${colors.white};
    border-width: 21px;
    margin-left: -21px;
  }
  &&::-webkit-scrollbar {
    width: 0px;
    background: transparent; /* make scrollbar transparent */
  }
`;
export const PaletteColors = styled.div`
  display: flex;
  width: 100%;
  height: 160px;
  flex-wrap: wrap;
`;
export const PaletteColor = styled.div`
  width: 30px;
  height: 30px;
  margin: 10px 0 0 10px;
  border-radius: 4px;
  background: ${props => props.color};
  cursor: pointer;
  ${props => props.used && css`
    border: 1px solid white;
    width: 28px;
    height: 28px;
  `}
  ${props => props.selected && css`
    border: 2px solid white;
    width: 26px;
    height: 26px;
  `}
`;

export const ColorPickerInput = styled.input`
  height: 30px;
  padding: 5px;
  box-sizing: border-box;
  width: calc(100% - 100px);
  border-radius: 4px;
  outline: 0;
  border: none;
  font-size: 22px;
  padding: 5px;
  text-transform: uppercase;
  letter-spacing: 1px;
  position: absolute;
  right: 10px;
  bottom: 10px;
  ${props =>
    props.error &&
    css`
      border: 1px solid red;
    `}
`;

// style manager
export const StyleManager = styled.div`
  width: auto;
  min-width: 220px;
  height: 60px;
  border: 1px solid ${colors.white};
  margin-right: 50px;
  border-radius: 10px;
  position: relative;
  cursor: pointer;
  ${props => props.ignoreOverlay && css`z-index: 9999;`}
`;
export const StyleManagerText = styled.div`
  width: 130px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: left;
  padding-left: 5px;
  margin: 10px;
  font-size: 20px;
  font-family: 'Ubuntu Mono';
  color: ${props => props.c};
  background-color: ${props => props.bg || 0};
  ${props => props.content && css`
    min-width: 0;
    white-space: nowrap; 
    overflow: hidden;
    text-overflow: ellipsis;
  `}
  ${props =>
    props.u &&
    css`
      text-decoration: underline;
      text-decoration-color: ${props => props.c};
    `}
  ${props =>
    props.b &&
    css`
      font-weight: bolder;
    `}
  ${props =>
    props.i &&
    css`
      font-style: italic;
    `}
`;


export const StyledWordInput = styled.input`
  height: 40px;
  margin: 10px 5px;
  box-sizing: border-box;
  width: calc(100% - 80px);
  border-radius: 4px;
  outline: 0;
  background: 0;
  font-size: 20px;
  font-family: 'Ubuntu Mono';
  padding-left: 5px;
  color: ${props => props.c};
  background-color: ${props => props.bg || 0};
  ${props =>
    props.u &&
    css`
      text-decoration: underline;
      text-decoration-color: ${props => props.c};
    `}
  ${props =>
    props.b &&
    css`
      font-weight: bolder;
    `}
  ${props =>
    props.i &&
    css`
      font-style: italic;
    `}
`;
export const StyledWordsContainer = styled.div`
  width: 100%;
  height: calc(100%);
  overflow: auto;
`;
export const StyledWordOption = styled.div`
	width: calc(100% - 20px);
	height: 41px;
	border-bottom: ${props => props.borderBottom ? `3px solid ${colors.white}` : `1px solid ${colors.white}`};
	display: flex;
	vertical-align: center;
	align-items: center;
	justify-content: left;
	font-size: 20px;
	position: relative;
  padding-left: 20px;
  font-family: 'Ubuntu Mono';
	color: ${props => props.c};
  background-color: ${props => props.bg || 0};
	${props =>
    props.u &&
    css`
      text-decoration: underline;
      text-decoration-color: ${props => props.c};
    `}
	${props =>
    props.b &&
    css`
      font-weight: bolder;
    `}
	${props =>
    props.i &&
    css`
      font-style: italic;
    `}

`;



export const StyleEditOptions = styled.div`
  position: absolute;
  right: 5px;
  top: 14px;
  display: flex;
`
export const StyleEditIcon = styled.div`
  background-image: url('${props => props.icon}');
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
  width: 20px;
  height: 20px;
  margin: 6px 8px 0 0;
  z-index: 9999;
  ${props => props.right && css`
    position: absolute;
    right: 0;
    top: 3px;
  `}
`;

